import { render, staticRenderFns } from "./Priorities.vue?vue&type=template&id=62f5ce66"
import script from "./Priorities.vue?vue&type=script&lang=js"
export * from "./Priorities.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports